<div class="list-mode-switcher">
  <button
    *ngIf="useMode.includes('list')"
    tuiIconButton
    class="button"
    type="button"
    iconStart="@tui.list"
    [appearance]="'icon'"
    [tuiAppearanceState]="mode === 'list' ? 'active' : null"
    [size]="size"
    (click)="onChangeMode('list')"
  ></button>

  <button
    *ngIf="useMode.includes('grid')"
    tuiIconButton
    class="button"
    type="button"
    iconStart="@tui.square"
    [appearance]="'icon'"
    [tuiAppearanceState]="mode === 'grid' ? 'active' : null"
    [size]="size"
    (click)="onChangeMode('grid')"
  ></button>

  <button
    *ngIf="useMode.includes('map')"
    tuiIconButton
    class="button"
    type="button"
    iconStart="@tui.map"
    [appearance]="'icon'"
    [tuiAppearanceState]="mode === 'map' ? 'active' : null"
    [size]="size"
    (click)="onChangeMode('map')"
  ></button>
</div>
